import {Button, Divider, message, Tooltip} from "antd";
import React, {Component} from "react";
import {C240SlideStatus, slideType} from "../../../utils/const";
import {isNull} from "../../../utils/utils";


const STAIN_TYPE = {
    HNE: "hne",
    PAP: "pap",
    IHC: "ihc"
}

export default class CassetteLevelActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scanningMode: "MEDIUM",
            stainType: STAIN_TYPE.HNE,
            disableScanAllButton: false,
            disablePreviewAllButton: false
        }
    }

    handleScanAll = () => {
        let showWarning = false;
        let directScanSlides = [];
        for (let i=0; i<6; i++) {
            const slideKey = this.props.selectedCassette + `S${i}`;
            const slideState = (this.props.status[slideKey] || {}).slideState;
            if (isNull(slideState) || slideState === C240SlideStatus.INITIAL) {
                showWarning = true;
                directScanSlides.push("Slide-" + (i+1).toString());
            }
        }
        this.props.queueForScan(0, true, this.state.stainType, this.state.scanningMode);
        directScanSlides = directScanSlides.join(", ");
        if (showWarning) {
            message.warn(`Slides without confirmed area selection will be queued for direct scans: ${directScanSlides}`, 5);
        }
    }

    handlePreviewAll = () => {
        let showWarning = false;
        let skippedSlides = [];
        for (let i=0; i<6; i++) {
            const slideKey = this.props.selectedCassette + `S${i}`;
            console.log("status: ", this.props.status, slideKey);
            const slideState = (this.props.status[slideKey] || {}).slideState;
            if (slideState !== undefined && slideState !== C240SlideStatus.INITIAL) {
                showWarning = true;
                skippedSlides.push("Slide-" + (i+1).toString());
            }
        }
        this.props.queueForPreview(0, true);
        skippedSlides = skippedSlides.join(", ");
        if (showWarning) {
            message.warn(`Slides for which a preview has already been taken will not be queued: ${skippedSlides}.`, 5);
        }
    }

    render() {

        return (
            <>
                <Divider />
                <div style={{height: "30px", display: "flex", justifyContent: "flex-start", marginTop: "10px",
                    marginBottom: "10px", marginLeft: "100px"}}>
                        {this.props.mySlideType === slideType.SLIDE_1_BY_3_INCH ? 
                    <div style={{display: "flex", justifyContent: "space-between", width: "430px"}}>
                        <Tooltip placement={"bottom"} title={"Scan all slides for which only preview is taken."}>
                            <Button onClick={this.handleScanAll} className="black-scan-btn" style={{height: "100%", width: "200px", textAlign: "center"}}>
                                Queue All 6 For Scan
                            </Button>
                        </Tooltip>
                        <Tooltip placement={"bottom"} title={"Queue Preview for all slides where preview is not taken."}>
                            <Button className="black-scan-btn" onClick={this.handlePreviewAll}
                                    style={{height: "100%", width: "200px", textAlign: "center", marginLeft: "10px"}}>
                                Queue All 6 For Preview
                            </Button>
                        </Tooltip>
                    </div> : null}
                </div>
                <Divider />
            </>
        )
    }
}